var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHacknroll2020Logo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 504.57 592.44",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M230.21,371.48a54.86,54.86,0,0,1-27,4.27c-27.13-2.44-46.63-21.29-46.47-45.43.13-17.67,11-26.9,23.72-33.62",
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10,
      strokeWidth: 2
    }
  }))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Original2") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("polygon", {
    points: "160.84 25.23 180.21 16.09 222.7 19.03 202.82 28.06 160.84 25.23",
    style: {
      fill: "#fac92d"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "281.82 11.31 301.48 2.4 342.82 5.32 323.65 14.48 281.82 11.31",
    style: {
      fill: "#fac92d"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "282.13 54.17 282.04 64.92 242.59 62.08 262.01 52.91 282.13 54.17",
    style: {
      fill: "#fac92d"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "161.58 449.72 180.95 440.6 224.15 443.57 205.68 452.69 161.58 449.72",
    style: {
      fill: "#fac92d"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "242.34 484.16 262.07 474.93 275.64 475.94 273.41 480.55 270.64 483.38 266.89 484.89 261.34 485.25 250.15 484.66 242.34 484.16",
    style: {
      fill: "#fac92d"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "260.44 549.88 279.2 541.57 315.63 535.32 297.71 543.6 260.44 549.88",
    style: {
      fill: "#fac92d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.66,259.55a62.65,62.65,0,0,0,6.77-4.58,54.85,54.85,0,0,0,4.35-5.81l1.07-5.1-.83-4.47-2.17-3s-2.82-2.43-4.39-2.06-3.86-.43-6.08,1.78-3,6.77-2.69,9.55,1.84,8.05,2.31,10.05A11.81,11.81,0,0,0,235.66,259.55Z",
    style: {
      fill: "#fac92d"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "282.14 361.23 302.53 342.52 316.7 336.55 321.53 335.04 301.52 353.4 293.12 356.94 282.14 361.23",
    style: {
      fill: "#fac92d"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "220.49 374.65 228.62 372.14 237.85 367.27 254.34 359.93 252.39 362.01 245.56 366.18 239.42 369.37 232.93 372.1 227.71 373.77 222.54 374.65 220.49 374.65",
    style: {
      fill: "#fac92d"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "334.67 287.9 354.97 279.88 351.78 287.35 348.29 294.3 343.96 300.68 324.06 308.57 327.93 302.56 331.78 295.63 334.67 287.9",
    style: {
      fill: "#fac92d"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "324.06 14.48 343.73 5.32 345.57 142.97 325.76 151.88 324.06 14.48",
    style: {
      fill: "#e73e28"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "203.16 28.06 223.1 19.05 224.72 156.72 204.99 165.62 203.16 28.06",
    style: {
      fill: "#e73e28"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "205.68 452.69 224.15 443.57 225.55 581.3 205.68 589.95 205.68 452.69",
    style: {
      fill: "#e73e28"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "297.71 543.6 317.35 535.02 343.31 581.3 323.21 590.33 297.71 543.6",
    style: {
      fill: "#e73e28"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242,416.89l18.46-9.05s30.45,2.38,39.45,4.89a61.25,61.25,0,0,1,16.38,7.61l8.16,7.07,6.18,8.63,2.71,5.86,2.78,10.31.87,10-.82,12L333.23,485l-4.72,8.73s-5.39,7.24-10.17,9.57-18.48,8.6-18.48,8.6,5.79-5.16,8.1-8.28a47.61,47.61,0,0,0,7.58-16.13c1.69-6.95,1.51-18.89,1.51-18.89s-.8-11.32-3.11-16.22-4.46-11-9.72-16-7.84-7.57-13.33-10.2-12.59-5.67-19.23-6.36-16.05-1.94-19.7-2.17S242,416.89,242,416.89Z",
    style: {
      fill: "#e73e28"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.54,210.41l16.29-7.06s10.28-3.18,18.7-1.8,16.31,2.23,23,7.29,11.22,7.41,15,16.85,2.88,17.56,1,22.23-6,12.65-10.88,15.36-6.22,4.36-8.18,5.42-9.22,4.5-9.22,4.5l16.26,19.31,36.11,41.56-20.05,8.45L280.64,318l-7.83-9.05-9.62-10.61-8.57-11-4.46-5.69,4.67-2.13,5.2-2.73,6.63-4.47A32.07,32.07,0,0,0,273,266.2c2.5-3.41,4.4-4.94,5.35-9.45s2.25-11.58,1.6-14.6-3.16-11.13-5.6-13.77-6.24-7.72-9.14-9.33-9.32-6.43-16.91-7.71S229.05,209.61,224.54,210.41Z",
    style: {
      fill: "#e73e28"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.45,296.7l19.17-8.07L216,310.09s-6.22,5.22-5.89,9.87a37.42,37.42,0,0,0,.79,6.3,9.38,9.38,0,0,0,3.29,5.37c2.8,2.25,4.73,3.71,7.39,4.22a36.35,36.35,0,0,0,10.07.49,10.05,10.05,0,0,0,4.56-1.84l21.12,24.09-19.5,8.68-21.12-23.58s-6.88,1.47-7.95,1.5-9.15-.63-12.57-3.54-5.64-7.3-5.63-9.27.32-7.77,2.13-9.82,3.69-3.92,3.69-3.92Z",
    style: {
      fill: "#e73e28"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "309.76 264.92 329.93 256.75 354.97 279.88 334.67 287.9 309.76 264.92",
    style: {
      fill: "#e73e28"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "180.21 16.09 160.84 25.23 162.41 162.37 204.99 165.62 224.72 156.72 223.1 19.05 180.21 16.09",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "160.84 25.23 203.16 28.06 223.1 19.05",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 203.16,
    y1: 28.06,
    x2: 204.99,
    y2: 165.62,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "262.01 52.91 242.59 62.08 242.59 96.43 282.65 99.28 283.36 148.8 325.76 151.88 345.57 142.97 343.73 5.32 301.48 2.4 281.82 11.31 282.13 54.17 262.01 52.91",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "242.59 62.08 282.04 64.92 282.13 54.17",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "281.82 11.31 324.06 14.48 343.73 5.32",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 324.06,
    y1: 14.48,
    x2: 325.76,
    y2: 151.88,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M260,201.6c23.62,2.36,40.25,17.59,39.93,36.82-.32,19.43-14.78,28.22-29.75,34.78l35.08,41.65c5.4,5.84,11,12.3,17.29,19.22L301.52,353.4l-20,8.44",
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10,
      strokeWidth: 2
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M235.63,259.59c7-3.82,12.07-8.43,12.19-15.49.09-5.3-3.15-9.17-7.92-9.64-5.12-.51-8.13,3.51-8.24,9.79-.07,4.51,1,9.33,4,15.34",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.24,323.29c5.4,5.85,11,12.31,17.29,19.23l-21.06,19.32c-5.94-6.69-11.34-12.93-16.38-18.74,0,0-52.76-66.62-56.42-71.51-6.77-11.87-9-20.75-8.85-30.37.37-21.78,15.79-33.61,40.16-31.18,23.63,2.36,40.26,17.6,39.93,36.83-.32,19.43-14.78,28.21-29.75,34.77q5.64,7.35,13.47,16.68",
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10,
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.69,210.78l13.89-6S245.37,200,260,201.6",
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10,
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 302.53,
    y1: 342.52,
    x2: 322.58,
    y2: 334.07,
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10,
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 208.67,
    y1: 271.59,
    x2: 265.09,
    y2: 343.1,
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10,
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 263.63,
    y1: 298.32,
    x2: 285.24,
    y2: 323.29,
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10,
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.53,283.16a53.11,53.11,0,0,0,7.23-18.24l20.16-8.17L355,279.89s-6,15.43-11,20.79l-20.3,8Z",
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10,
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.67,308.72s9.14-12.47,11-20.82l20.3-8",
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10,
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 309.76,
    y1: 264.92,
    x2: 334.67,
    y2: 287.9,
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10,
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#a)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M180.45,296.7c-12.71,6.72-23.59,15.95-23.72,33.62-.16,24.14,19.34,43,46.47,45.43a54.86,54.86,0,0,0,27-4.27",
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10,
      strokeWidth: 2
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M230.21,371.48a54.86,54.86,0,0,1-27,4.27c-27.13-2.44-46.63-21.29-46.47-45.43.13-17.67,11-26.9,23.72-33.62",
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10,
      strokeWidth: 2
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M229.39,371.83a78.38,78.38,0,0,0,8.46-4.56l-21.12-24.09c-4.69,2.73-11.39,1.91-11.39,1.91-8.62-.77-14.82-6.83-14.76-15.46,0-4.52,2.26-7.85,5.95-10.86L216,310.09c-3.68,3-5.91,6.34-5.94,10.86-.06,8.64,6.14,14.69,14.76,15.47,0,0,6.7.81,11.39-1.92l21.12,24.09-19.5,8.68",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218,375.14s14.51,1.37,39.35-16.55",
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10,
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 216.73,
    y1: 343.18,
    x2: 236.23,
    y2: 334.5,
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10,
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "196.53 318.77 180.45 296.7 199.62 288.63 216.03 310.09",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 199.92,
    y1: 233.93,
    x2: 79.44,
    y2: 233.93,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 160.39,
    y1: 58.83,
    x2: 39.91,
    y2: 58.83,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 466.21,
    y1: 108.12,
    x2: 345.73,
    y2: 108.12,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 157.61,
    y1: 322.02,
    x2: 37.13,
    y2: 322.02,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.47,55v7H13.85v-5.7h-1.4V55Z",
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 14.51,
    cy: 58.44,
    r: 8.55,
    style: {
      fill: "none",
      stroke: "#1d1d1b",
      strokeMiterlimit: 10,
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 468.32,
    y1: 273.13,
    x2: 347.83,
    y2: 273.13,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M493.55,110.39v1.32h-5.29v-1l2.7-2.55a2.91,2.91,0,0,0,.58-.71,1.25,1.25,0,0,0,.15-.58.79.79,0,0,0-.29-.65,1.3,1.3,0,0,0-.83-.22,2,2,0,0,0-.83.17,1.59,1.59,0,0,0-.62.53l-1.18-.76a2.73,2.73,0,0,1,1.13-1,3.77,3.77,0,0,1,1.65-.34,3.37,3.37,0,0,1,1.36.25,2.07,2.07,0,0,1,.91.72,1.86,1.86,0,0,1,.33,1.1,2.43,2.43,0,0,1-.24,1.07,4.22,4.22,0,0,1-.93,1.14l-1.61,1.52Z",
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 490.96,
    cy: 108.42,
    r: 8.55,
    style: {
      fill: "none",
      stroke: "#1d1d1b",
      strokeMiterlimit: 10,
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.92,234.06a1.84,1.84,0,0,1,.49,1.32,2,2,0,0,1-.32,1.12,2.22,2.22,0,0,1-1,.83,3.7,3.7,0,0,1-1.61.31,5.08,5.08,0,0,1-1.45-.2,3.8,3.8,0,0,1-1.22-.55l.63-1.24a3.39,3.39,0,0,0,.93.47,3.56,3.56,0,0,0,1.07.16,1.66,1.66,0,0,0,1-.24.72.72,0,0,0,.35-.66c0-.57-.43-.86-1.31-.86h-.74v-1.07l1.44-1.63h-3v-1.3h4.9v1l-1.58,1.8A2.3,2.3,0,0,1,55.92,234.06Z",
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 53.88,
    cy: 233.93,
    r: 8.55,
    style: {
      fill: "none",
      stroke: "#1d1d1b",
      strokeMiterlimit: 10,
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M496.85,275.25h-1.14v1.47h-1.58v-1.47h-3.77v-1.09l3.3-4.44h1.7l-3.06,4.21h1.88v-1.31h1.53v1.31h1.14Z",
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 493.75,
    cy: 273.13,
    r: 8.55,
    style: {
      fill: "none",
      stroke: "#1d1d1b",
      strokeMiterlimit: 10,
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.71,321.83a2,2,0,0,1,.7,1.58,2.14,2.14,0,0,1-.32,1.16,2.24,2.24,0,0,1-1,.84,3.74,3.74,0,0,1-1.62.32,5.51,5.51,0,0,1-1.45-.2A3.8,3.8,0,0,1,7.83,325l.64-1.24a3.17,3.17,0,0,0,.92.46,3.57,3.57,0,0,0,1.07.17,1.66,1.66,0,0,0,1-.24.82.82,0,0,0,0-1.35,2.46,2.46,0,0,0-1.27-.23H8.35l.36-3.94H13v1.3H10.06L10,321.24h.57A3.39,3.39,0,0,1,12.71,321.83Z",
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 10.76,
    cy: 322.02,
    r: 8.55,
    style: {
      fill: "none",
      stroke: "#1d1d1b",
      strokeMiterlimit: 10,
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.56,513c-13.32,9.29-55.22,5.54-55.22,5.54V484.16s10.46.47,17.07,1a31,31,0,0,0,7.48-.26,9.37,9.37,0,0,0,5.45-3c2.21-2.47,4.83-7,3.75-14.24-1.78-11.8-7.87-14.71-21-15.64L242,451.09v-34.2l20.11,1.74c34.61,2.42,54.69,21.58,55.09,52.59.26,19.62-6.52,34-19.6,41.75l19.79-9c13.07-7.7,19.86-22.13,19.6-41.75",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "242.34 484.16 262.07 474.93 275.64 475.94",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242,416.89l18.46-9.05,21.44,1.76c34.61,2.42,54.68,21.58,55.09,52.58.26,19.62-6.53,34.05-19.6,41.75l-19.79,9c13.08-7.7,19.86-22.13,19.6-41.75",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 454.29,
    y1: 441.9,
    x2: 333.81,
    y2: 441.9,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "180.95 440.6 161.58 449.72 162.88 586.68 205.68 589.95 225.55 581.3 224.15 443.57 180.95 440.6",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "205.68 589.95 205.68 452.69 224.15 443.57",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 161.58,
    y1: 449.72,
    x2: 205.68,
    y2: 452.69,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 161.35,
    y1: 475,
    x2: 40.86,
    y2: 475,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "259.33 550.37 275.36 587.17 323.21 590.33 343.31 581.3 317.35 535.02 297.71 543.6 259.33 550.37",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "259.33 550.37 279.2 541.57 317.35 535.02",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 297.71,
    y1: 543.6,
    x2: 323.22,
    y2: 590.33,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 457.44,
    y1: 569.07,
    x2: 336.96,
    y2: 569.07,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.5,472v1l-2.6,6H13.14l2.51-5.68H13.33v1.14H11.89V472Z",
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 14.66,
    cy: 475,
    r: 8.55,
    style: {
      fill: "none",
      stroke: "#1d1d1b",
      strokeMiterlimit: 10,
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M481,441.15a2.08,2.08,0,0,1,.87.76,2.11,2.11,0,0,1,.32,1.15,2.19,2.19,0,0,1-.35,1.23,2.28,2.28,0,0,1-.95.81,3.17,3.17,0,0,1-1.35.29,3,3,0,0,1-2.3-.9,3.68,3.68,0,0,1-.83-2.57,4.33,4.33,0,0,1,.45-2,3,3,0,0,1,1.26-1.29,3.82,3.82,0,0,1,1.86-.44,4.83,4.83,0,0,1,1.08.12,3.16,3.16,0,0,1,.87.36l-.6,1.19a2.32,2.32,0,0,0-1.31-.35,1.9,1.9,0,0,0-1.41.52,2.18,2.18,0,0,0-.56,1.51,2.35,2.35,0,0,1,1.73-.62A2.73,2.73,0,0,1,481,441.15Zm-.7,2.75a1,1,0,0,0,.32-.76,1,1,0,0,0-.32-.77,1.28,1.28,0,0,0-.87-.28,1.32,1.32,0,0,0-.87.29,1,1,0,0,0-.34.76.94.94,0,0,0,.33.75,1.33,1.33,0,0,0,.9.29A1.25,1.25,0,0,0,480.29,443.9Z",
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 479.36,
    cy: 441.68,
    r: 8.55,
    style: {
      fill: "none",
      stroke: "#1d1d1b",
      strokeMiterlimit: 10,
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M485.45,569.44a1.68,1.68,0,0,1,.28,1,1.85,1.85,0,0,1-.37,1.13,2.48,2.48,0,0,1-1,.75,4.58,4.58,0,0,1-3.1,0,2.44,2.44,0,0,1-1-.75,1.84,1.84,0,0,1-.36-1.13,1.75,1.75,0,0,1,.27-1,2,2,0,0,1,.79-.68,1.75,1.75,0,0,1-.6-.61,1.63,1.63,0,0,1-.21-.83,1.68,1.68,0,0,1,.34-1.06,2.1,2.1,0,0,1,.95-.7,3.77,3.77,0,0,1,1.4-.24,3.86,3.86,0,0,1,1.41.24,2.18,2.18,0,0,1,1,.7,1.74,1.74,0,0,1,.34,1.06,1.63,1.63,0,0,1-.21.83,1.78,1.78,0,0,1-.61.61A2,2,0,0,1,485.45,569.44Zm-1.72,1.65a.87.87,0,0,0,.36-.73.86.86,0,0,0-.36-.73,1.54,1.54,0,0,0-1-.27,1.51,1.51,0,0,0-.95.27.85.85,0,0,0-.35.73.87.87,0,0,0,.35.74,1.51,1.51,0,0,0,.95.27A1.54,1.54,0,0,0,483.73,571.09ZM482,566.74a.8.8,0,0,0-.29.65.76.76,0,0,0,.29.63,1.24,1.24,0,0,0,.79.23,1.31,1.31,0,0,0,.8-.23.77.77,0,0,0,.3-.63.78.78,0,0,0-.3-.65,1.25,1.25,0,0,0-.8-.23A1.22,1.22,0,0,0,482,566.74Z",
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 482.51,
    cy: 568.84,
    r: 8.55,
    style: {
      fill: "none",
      stroke: "#1d1d1b",
      strokeMiterlimit: 10,
      strokeWidth: 2
    }
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHacknroll2020Logo);
export default __webpack_public_path__ + "static/media/hacknroll-2020-logo.9e183f4828dbf85e606d487a7cb88c44.svg";
export { ForwardRef as ReactComponent };